import React from 'react';
import { Box } from 'workspace-core-ui';

const Break = ({ ...delegated }) => <Box my={3} {...delegated} />;

export default Break;
